import signedFetch from '../util/signedFetch.js';

export default data =>
  signedFetch('userAdminEdit', `${__API_BASE__}/admin-console/user/edit/${data.userId}`, 'PUT', {
    firstName: data.firstName,
    lastName: data.lastName,
    userEmail: data.email
  });
